import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import {reduxForm} from "redux-form";
import {GetPackageOne, AddPackage, EditPackage, delPackage, GetInterfaceLang, GetOneLearningLanguage, GetPackages} from '../../actions/index';
import _ from 'lodash';

class PackageEdit extends Component {
    static contextTypes = {
        router: PropTypes.object,
        fields: PropTypes.object
    };
    constructor(props){
        super(props);
        this.delPackageOpenModal = this.delPackageOpenModal.bind(this);
        this.delPackageInModal = this.delPackageInModal.bind(this);
        this.SubmitForm = this.SubmitForm.bind(this);
        this.renderName = this.renderName.bind(this);
        this.removeClass = this.removeClass.bind(this);
        this.checkboxChange = this.checkboxChange.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        let package_id = localStorage.getItem('id_package');
        if(this.props.params.id_package){
            this.props.GetPackageOne(token, this.props.params.id_package)
        }
        this.props.GetInterfaceLang(token);
        this.props.GetOneLearningLanguage(package_id, token);
        this.props.GetPackages(token, package_id);
    }
    componentWillUnmount(){
        this.props.subscription.package_one = {};
    }
    delPackageInModal(){
        let token = localStorage.getItem('id_token_admin');
        this.props.delPackage(token, this.props.subscription.package_one.id).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.context.router.push('/subscription/packages/package/');
            }
        });
    }
    removeClass(e){
        $(e.target).parent().removeClass('has-error');
        if(e.target.name == 'price' || e.target.name == 'term' || e.target.name == 'position'){
            this.props.fields[e.target.name].onChange(e.target.value)
        }
    }
    delPackageOpenModal(){
        $('#delPackage').modal('show');
    }
    closeModal(){
        $('#delPackage').modal('hide');
    }
    SubmitForm(){
        let token = localStorage.getItem('id_token_admin');
        let package_id = localStorage.getItem('id_package');
        let block = $('.addWordBlock');
        let arr = [];
        let props = {};
        for(let i=0; i<block.length; i++){
            let oneBlock = block[i];
            if($(oneBlock).find('input').val() != ''){
                if($(oneBlock).find('.idetBlock').html() != '' && $(oneBlock).find('.idetBlock').html() != '<p><br></p>'){
                    let obj={
                        description: $(oneBlock).find('.idetBlock').html(),
                        blang: parseInt($(oneBlock).closest('.sentences').attr('id')),
                        title: $(oneBlock).find('input').val()
                    };
                    arr.push(obj)
                }else{
                    $(oneBlock).find('.idetBlock').parent().addClass('has-error');
                }
            }else{
                $(oneBlock).find('input').parent().addClass('has-error');
            }
        }
        if($('#price').val() != ''){
            if($('#term').val() != ''){
                let toFix = Number.parseFloat($('#price').val());
                props = {
                    translations: arr,
                    price: toFix.toFixed(2),
                    flang: parseInt(package_id),
                    position: parseInt($('#position').val()),
                    is_most_popular: $('#is_most_popular').is(':checked'),
                    is_best_price: $('#is_best_price').is(':checked'),
                    term: parseInt($('#term').val())
                };
            }else{
                $('#term').parent().addClass('has-error');
            }
        }else{
            $('#price').parent().addClass('has-error');
        }
        if($('.formPackage').find('.has-error').length > 0){return false}else {
            if(this.props.params.id_package){
                this.props.EditPackage(token, props, this.props.params.id_package).then((response)=>{
                    if(response.payload.status == 200){
                        this.context.router.push('/subscription/packages/package/');
                    }
                });
            } else {
                this.props.AddPackage(token, props).then((response)=>{
                    if(response.payload.status == 201){
                        this.context.router.push('/subscription/packages/package/');
                    }
                });
            }
        }

    }
    componentWillUnmount(){
        this.props.subscription.packages = {};
        this.props.subscription.error = '';
    }
    edit(e){
        let block = $(e.target).data('id')
        $('#'+block+' .idetBlock').summernote({
            lang: "ru-RU",
            height: 150,
            dialogsInBody: true,
            toolbar: [
                ["font", ["bold", "underline", "clear"]],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ["para", ["ul", "ol", "paragraph"]],
                ["table", ["table"]],
                ["insert", ["link", "picture", "video"]],
                ["view", ["fullscreen", "codeview"]]
            ]
        });
        $('#'+block+' .btn-primary').show();
    };
    save(e){
        let block = $(e.target).data('id')
        let makrup = $('#'+block+' .idetBlock').summernote('code');
        $('#'+block+' .idetBlock').summernote('destroy');
        $('#'+block+' .btn-primary').hide();
        $('#'+block+' .idetBlock').parent().removeClass('has-error');
    };
    editTranslation(id, name){
        if(this.props.params.id_package){
            let item = _.findWhere(this.props.subscription.package_one.translations, {blang: id});
            if(_.findWhere(this.props.subscription.package_one.translations, {blang: id})){
                return(
                    <div className="col-md-12 row_for_translate addWordBlock" key={item.blang} id={name}>
                        <div className="row">
                            <div className="col-md-4" id={item.blang}>
                                <label>Name package</label>
                            </div>
                            <div className="col-md-4" id={item.blang}>
                                <input type="text" className="form-control" defaultValue={item.title} onChange={this.removeClass}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4" id={item.blang}>
                                <label>Description</label>
                            </div>
                            <div className="col-md-4" id={item.blang}>
                                <div className="idetBlock" dangerouslySetInnerHTML={{__html: item.description}}></div>
                                <div className="blockBtn">
                                    <button id="edit" data-name={id} data-id={name} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                    <button id="save" data-name={id} data-id={name} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                                </div>

                            </div>
                        </div>
                    </div>
                )
            }
            // <textarea className="form-control" name={item.blang} defaultValue={item.description} onChange={this.removeClass}/>
            else{
                return(
                    <div className="col-md-12 row_for_translate addWordBlock" id={name}>
                        <div className="row">
                            <div className="col-md-4" id={id}>
                                <label>Name package</label>
                            </div>
                            <div className="col-md-4" id={id}>
                                <input type="text" className="form-control" onChange={this.removeClass}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4" id={id}>
                                <label>Description</label>
                            </div>
                            <div className="col-md-4" id={id}>
                                <div className="idetBlock" dangerouslySetInnerHTML={{__html: ''}}></div>
                                <div className="blockBtn">
                                    <button id="edit" data-name={id} data-id={name} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                    <button id="save" data-name={id} data-id={name} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                                </div>

                            </div>
                        </div>
                    </div>
                )
            }
            // <textarea className="form-control" name={id} onChange={this.removeClass}/>
        }else{
            return(
                <div className="col-md-12 row_for_translate addWordBlock" id={name}>
                    <div className="row">
                        <div className="col-md-4" id={id}>
                            <label>Name package</label>
                        </div>
                        <div className="col-md-4" id={id}>
                            <input type="text" className="form-control" onChange={this.removeClass}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4" id={id}>
                            <label>Description</label>
                        </div>
                        <div className="col-md-4" id={id}>
                            <div className="idetBlock" dangerouslySetInnerHTML={{__html: ''}}></div>
                            <div className="blockBtn">
                                <button id="edit" data-name={id} data-id={name} className="btn btn-default" onClick={this.edit} type="button">Edit</button>
                                <button id="save" data-name={id} data-id={name} className="btn btn-primary" onClick={this.save} type="button">Save</button>
                            </div>

                        </div>

                    </div>
                </div>
            )
        }
        // <textarea className="form-control" name={id} onChange={this.removeClass}/>
    }
    getTitleById(id, translations) {
        let result = '';
        translations.forEach(function(item, i){
            if(item.blang == id) {
                result = item.title;
            }
        });
        return result
    }
    renderName(id){
        return this.props.subscription.package_one.translations.map((item, i)=> {
            // return this.getTitleById(parseInt(id), item.translations);
            if(item.blang == id){
                let result = item.title;
                return result ;
            }
        })
    }
    renderTranslate(){
        let elem = this.props.lang.interface_lang.results;
        return elem.map((item)=>{
            // if(item.lang.id == this.props.lang.learning_lang_one.lang.id){
            //     return false
            // }else{
            return(
                <div className="col-md-12" key={item.lang.id}>
                    <div className='row sentences' id={item.id}>
                        <div className="col-md-12">
                            <p className="name_language">{item.lang.name}</p>
                        </div>
                        {this.editTranslation(item.id, item.lang.name)}
                    </div>
                </div>
            )
            // }
        });
    }
    checkboxChange(e){
        if(e.target.id == 'is_best_price'){
            this.props.fields.is_most_popular.onChange(false)
        }else{
            this.props.fields.is_best_price.onChange(false)
        }
        this.props.fields[e.target.id].onChange(e.target.value)

    }
    render() {
        let package_id = localStorage.getItem('id_package');
        const { fields: {
            term,
            position,
            is_best_price,
            is_most_popular,
            price}, handleSubmit} = this.props;
        return (
            <div className="dashboard-wrapper">
                {this.props.params.id_package && this.props.subscription.packages.results && this.props.subscription.package_one && this.props.subscription.package_one.translations ? <p className="dashboard-title">{this.renderName(package_id)} </p> : <p className="dashboard-title">Add Package</p>}
                <p className="dashboard-text">Subscription</p>
                {this.props.lang.interface_lang.results && this.props.lang.learning_lang_one.lang && this.props.subscription.package_one != undefined ?
                    <div className="formPackage white-block clearfix">
                        {this.renderTranslate()}
                        <div className="col-md-12">
                            <div className="row mb10">
                                <div className="col-md-4">
                                    <label>Value <span>(&euro;)</span></label>
                                </div>
                                <div className="col-md-4">
                                    <input type="number"
                                           className="form-control"
                                           id="price"
                                           name="price"
                                           {...price}
                                           onChange={this.removeClass}
                                    />
                                </div>
                            </div>
                            <div className="row mb10">
                                <div className="col-md-4">
                                    <label>Expiration time <span>(months)</span></label>
                                </div>
                                <div className="col-md-4">
                                    <input type="number"
                                           className="form-control"
                                           id="term"
                                           name="term"
                                           {...term}
                                           onChange={this.removeClass}
                                    />
                                </div>
                            </div>
                            <div className="row mb10">
                                <div className="col-md-4">
                                    <label>Position</label>
                                </div>
                                <div className="col-md-4">
                                    <input type="number"
                                           className="form-control"
                                           id="position"
                                           name="position"
                                           {...position}
                                           onChange={this.removeClass}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-2">
                                    <input type="radio"
                                           className=""
                                           id="is_best_price"
                                           name="for_label"
                                           {...is_best_price}
                                           onChange={this.checkboxChange}
                                    />
                                    <label htmlFor="is_best_price">Best price</label>
                                </div>
                                <div className="col-md-2">
                                    <input type="radio"
                                           className=""
                                           id="is_most_popular"
                                           name="for_label"
                                           {...is_most_popular}
                                           onChange={this.checkboxChange}
                                    />
                                    <label htmlFor="is_most_popular">Most popular</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""
                }
                <div className="white-block clearfix">
                    <div className="col-md-12 text-center button-group">
                        {this.props.subscription.error != '' ? <p className="error-p">Position is already used</p> : ""}
                        <Link to={"/subscription/packages/package/"} className="btn btn-default">Cancel</Link>
                        {this.props.params.id_package ? <button type="button" onClick={this.delPackageOpenModal} className="btn btn-danger">Delete</button> : ""}
                        <button type="button" onClick={this.SubmitForm} className="btn btn-primary">Save</button>
                    </div>
                </div>
                <div className="modal fade" id="delPackage" tabIndex="-1" role="dialog" aria-labelledby="DelPackageLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#delPackage" />
                                <p>Do you really want to delete this package?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delPackageInModal} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>

        );
    }
}

function validate(values) {
    const errors = {};
    if(!values.term){
        errors.term = 'Enter a title'
    }
    if(!values.price){
        errors.price = 'Enter a title'
    }
    return errors;
}

function  mapStateToProps(state) {
    return{
        lang: state.lang,
        subscription: state.subscription,
        initialValues: {
            term: state.subscription.package_one.term || '',
            price: Number.parseFloat(state.subscription.package_one.price) || '',
            position: Number.parseFloat(state.subscription.package_one.position) || '',
            is_best_price: state.subscription.package_one.is_best_price || false,
            is_most_popular: state.subscription.package_one.is_most_popular || false
        }
    }
}
export default reduxForm({
    form: 'Add Rule',
    fields: ['term', 'price', 'position', 'is_most_popular', 'is_best_price'],
    validate
}, mapStateToProps, {GetPackageOne, AddPackage, EditPackage, delPackage, GetInterfaceLang, GetOneLearningLanguage, GetPackages})(PackageEdit);



// WEBPACK FOOTER //
// ./src/components/subscription/packageEdit.js